<template>
  <label v-if="$adminLocalizationEnabled()" class="admin-language-selector" :class="{ 'admin-language-selector-compact': compact }">
    <span class="admin-language-label">{{ $adminT('shared.language', 'Admin language') }}</span>
    <span class="admin-language-control">
      <select :value="$adminLocale()" @change="$setAdminLocale($event.target.value)">
        <option value="en">{{ compact ? 'EN' : 'English' }}</option>
        <option value="hr">{{ compact ? 'HR' : 'Hrvatski' }}</option>
      </select>
      <span class="admin-language-arrow" aria-hidden="true" />
    </span>
  </label>
</template>

<script>
export default {
  name: 'admin-language-selector',
  props: { compact: { type: Boolean, default: false } },
}
</script>

<style scoped>
.admin-language-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  color: #333333;
  font-family: 'Source Sans Pro', sans-serif;
}
.admin-language-control {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.admin-language-selector select {
  appearance: none;
  background: transparent;
  border: 1px solid #a0a0a0;
  border-radius: 4px;
  padding: 8px 32px 8px 10px;
  height: 38px;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  cursor: pointer;
  text-transform: none;
}
.admin-language-arrow {
  position: absolute;
  right: 12px;
  width: 7px;
  height: 7px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: translateY(-2px) rotate(45deg);
  pointer-events: none;
}
.admin-language-selector-compact {
  padding: 0;
}
.admin-language-selector-compact .admin-language-label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}
.admin-language-selector-compact select {
  width: 80px;
  border-color: transparent;
  font-size: 18px;
}
.admin-language-selector select:hover {
  background: #f5f5f5;
}
.admin-language-selector select:focus-visible {
  outline: 2px solid #0277bd;
  outline-offset: 2px;
}
</style>
